<template>

  <v-container grid-list-sm text-xs-left>
    <v-flex xs12 py-2>
      <span class="display-2" ref="news">News</span>
    </v-flex>
    <v-flex xs12 pt-2 pb-4>
    <span style="font-size:18px;" >
                Find out what's new in Discovery!
                  </span>
    </v-flex>
    <v-divider class="divider"/>


  <Carousel3d v-if="newsFlag"
              autoplay
      height="400"
      width="400"
      controlsVisible
      perspective="10"
      space="500"
      display="3"
      inverse-scaling="300"
      border="2"

  >
    <Slide v-for="(n, index) in news" :index="index"> <!-- @click.native="navigate(n._id)" -->
      <v-card height="400">
        <v-img
            :lazy-src="require('@/assets/img/innovation/loadingBlueGreen.gif')"
            :src="n.image"
            aspect-ratio="2.75"
            height="200px"
        >
        </v-img>

        <v-card-title primary-title>
          <v-flex xs12 class="headline block-ellipsis-title">{{n.title}}</v-flex>
          <v-flex xs12 class="block-ellipsis-description" v-html="n.content"></v-flex>

        </v-card-title>
<!--
        <v-card-text>
  <v-flex xs12><span class="font-weight-bold">Author: </span> {{n.author}} </v-flex>
  <v-flex xs12><span class="font-weight-bold">Date: </span> {{n.date}} </v-flex>
</v-card-text>
-->
        <v-card-actions>
          <v-btn
              slot="activator"
              color="blue"
              flat
              dark
              class="elevation-0"
              @click="navigate(n._id)"
          >
            Explore
          </v-btn>
        </v-card-actions>

      </v-card>

    </Slide>
  </Carousel3d>

  <v-flex v-else>
    No News
  </v-flex>

</v-container>
</template>

<script>

import RouterService from "@/helpers/RouterService";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
import TimeService from "@/helpers/TimeService";
import UrlsService from "@/helpers/UrlsService";

import { Carousel3d, Slide } from 'vue-carousel-3d';


export default {
  name: "PublicNews",
  components: {
    Carousel3d,
    Slide,
  },
  data() {
    return {
      published: true,
      header: "News",
      news: [],
      newsFlag: false,
    };
  },
  created() {
    this.getNews();
    Carousel3d.data().autoplayHoverPause.default=false;
  },
  methods: {
    navigate(id) {
      let path = {
        name: "PublicNewsDetails",
        params: {
          _id: id,
        },
      };
      RouterService.goTo(path);
    },
    getNews() {
      let requestUrl = {
        url: UrlsService.getNewsPublic,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
      };
      let requestObject = {
        type: "public",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "List News",
        //loading: "Waiting for list of news...",
        error: "Cannot get news...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            console.log("News: caricamento effettuato: ",responseSuccess);
            this.news = [];
            let responseNews = responseSuccess;

            for (let i = 0; i < responseNews.length; i++) {
              responseNews[i]['selected'] = false
              this.news.push(responseNews[i])
            }

            this.newsFlag = this.news.length !== 0;
          });
    },
  },
}
</script>

<style scoped>

.vcc {
  height: 50vh;
  width: 60vw;
}

.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.block-ellipsis-title {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  height: 35px;
  margin: 0 auto 0 0;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  overflow: hidden; /* auto (for vertical scrolling) or hidden */
}

.block-ellipsis-description {
  display: block;
  display: -webkit-box;
  max-width: 100%;
  height: 63px;
  margin: 0 auto 0 0;
  font-size: 14px;
  line-height: 1.5;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  overflow: hidden; /* auto (for vertical scrolling) or hidden */
}


.my-span {
  background-color: white;
  opacity: 0.5;
  color: black;
  font-weight: bold;
  margin-right: 5%;
  margin-top: 2.5%;
  float: right;
}

.divider {
    height: 2px;

    alignment: center;
    color: grey;
    border-color: grey;
}

</style>
